import React from "react";

import { Button, TextField, SelectionControl, SelectField } from 'lib/imports/react-md';
import { find, isEmpty, differenceBy } from 'lib/imports/lodash';

import { TProps, withT } from "lib/i18n";
import {
	ScopeSocial, SocialExpressionsType, DefinitionSocialInstagramAccount,
	anywhereScope, hashtagScope, mentionsScope, tapTagsScope, speechScope, sponsoredByScope, isMentionsScope
} from "class/Feed";
import FocusFeedDefinitionSocialInstagramAccountsList from "components/Focus/Feed/Definition/Social/Expression/InstagramAccountsList";
import FocusFeedDefinitionSocialInstagramAccount from "components/Focus/Feed/Definition/Social/Expression/InstagramAccount";
import { InstagramAccountObject } from "store/entities/InstagramAccount";

import "./FocusFeedDefinitionSocialExpression.scss";

type OwnProps = {
	expressionKey: SocialExpressionsType | "main"
	enabled: boolean
	query: string
	scope: ScopeSocial[]
	error?: true
	index: number
	instagramAccounts: InstagramAccountObject<'facebookUsers'>[] | null
	definitionInstagramAccounts: DefinitionSocialInstagramAccount[]
	onEnabledToggled: (enabled: boolean) => void
	onQueryChanged: (query: string) => void
	onCheckQuery: () => void
	onScopeChanged: (scope: ScopeSocial[]) => void
	onRemoveExpression?: () => void
	onInstagramAccountToggled?: (igAccount: DefinitionSocialInstagramAccount) => void
};

type ComponentProps = OwnProps & TProps;

class FocusFeedDefinitionSocialExpression extends React.Component<ComponentProps> {

	// TODO: change to functional component using hooks
	private queryInputRef: React.RefObject<any> = React.createRef();

	// TODO: change to functional component using hooks
	public componentDidMount() {
		if (isEmpty(this.props.query)) this.queryInputRef.current.focus();
	}


	public render() {
		const { t, expressionKey, enabled, query, scope, error, index, instagramAccounts, definitionInstagramAccounts } = this.props;
		const { onEnabledToggled, onInstagramAccountToggled, onQueryChanged, onCheckQuery, onScopeChanged, onRemoveExpression } = this.props;

		const isMainExpression = expressionKey === "main";
		const isExcludeExpression = expressionKey === "exclude_expressions";

		const selectedDefinitionInstagramAccount = find(definitionInstagramAccounts, { linkedExpression: { type: expressionKey, index } });
		const selectedInstagramAccount = (selectedDefinitionInstagramAccount && instagramAccounts) ? find(instagramAccounts, { id: selectedDefinitionInstagramAccount.id }) : undefined;
		const instagramAccountsToList = instagramAccounts ? differenceBy(instagramAccounts, definitionInstagramAccounts, 'id') : null;
		const shouldShowInstagramAccounts = isMentionsScope(scope) && !isExcludeExpression && !selectedInstagramAccount;

		let queryContent = <div></div>;
		if (selectedDefinitionInstagramAccount && selectedInstagramAccount) queryContent = (
			<FocusFeedDefinitionSocialInstagramAccount
				account={selectedInstagramAccount}
				removable={true}
				onSelected={() => onInstagramAccountToggled!({ id: selectedInstagramAccount.id, screen_name: selectedInstagramAccount.screen_name, linkedExpression: { type: expressionKey, index } })}
			/>
		);
		else if (!selectedDefinitionInstagramAccount) queryContent = (
			<TextField
				id={`focusFeedSocialExpressionQuery${expressionKey}${index}`}
				className={`definition-expressions-query ${error ? 'wrong-query' : ''}`}
				fullWidth={false}
				value={query}
				error={error}
				onChange={value => onQueryChanged(value.toString())}
				onBlur={() => onCheckQuery()}
				disabled={!enabled}
				ref={this.queryInputRef}
			/>
		);

		const removeExpressionButton = isMainExpression ? null : (
			<Button
				id={`focusFeedSocialExpressionRemove${expressionKey}${index}`}
				className='definition-expression-remove-button'
				icon
				onClick={() => onRemoveExpression ? onRemoveExpression() : null}
			>
				delete
			</Button>
		);

		let className = 'social-definition-expression content-expression';
		if (isMainExpression) className += " main-expression";
		else if (index === 0) className += " is-first-expression";
		className += enabled ? " enabled" : " disabled";
		return (
			<div className={className}>
				<SelectionControl
					id={`focusFeedDefinitionSocialExpressionEnabled${expressionKey}${index}`}
					name={`focusFeedDefinitionSocialExpressionEnabled${expressionKey}${index}`}
					aria-label={`focusFeedDefinitionSocialExpressionEnabled${expressionKey}${index}`}
					className={`definition-expression-enabled ${enabled ? "checkbox-green" : ''} `}
					type="checkbox"
					checked={enabled}
					onChange={val => onEnabledToggled(val as boolean)}
				/>
				{isMainExpression ?
					<span className="definition-expression-label">{t('feed.form.label.main_expression_social_media_react')}</span> :
					<span className="definition-expression-label">{t('feed.form.or')}</span>
				}
				<SelectField
					id={`focusFeedSocialDefinitionExpressionScope${expressionKey}${index}`}
					className="definition-expression-scope"
					menuItems={[
						{ value: anywhereScope.join(','), label: t('feed.form.scope.option.anywhere') },
						{ value: hashtagScope.join(','), label: t('feed.form.scope.option.tag') },
						{ value: mentionsScope.join(','), label: t('feed.form.scope.option.mention_react') },
						{ value: tapTagsScope.join(','), label: t('feed.form.scope.option.tap_tags') },
						{ value: speechScope.join(','), label: t('feed.form.scope.option.speech') },
						{ value: sponsoredByScope.join(','), label: t('feed.form.scope.option.sponsored_by') }
					]}
					onChange={val => onScopeChanged(val.toString().split(',') as ScopeSocial[])}
					value={scope.join(',')}
					disabled={!enabled}
				/>
				{queryContent}
				{removeExpressionButton}
				{shouldShowInstagramAccounts ?
					<FocusFeedDefinitionSocialInstagramAccountsList
						instagramAccounts={instagramAccountsToList}
						expressionKey={expressionKey as SocialExpressionsType}
						index={index}
					/>
					: null}
			</div>
		);
	}
}

export default withT(FocusFeedDefinitionSocialExpression);
